/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/share',
    component: () => import('@/views/Share/index.vue'),
    meta: {
      title: '分享',
      keepAlive: false
    },
    children: [
      {
        path: 'overdue/:id',
        component: () => import('@/views/Share/overdue/index.vue'),
        meta: {
          title: '逾期上岸不求人',
          keepAlive: false
        },
      },
    ]
  },
]